import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            14 Product Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Shop by Category
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Click any category below to explore curated product collections on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="text-background-50 text-xs md:text-sm font-semibold drop-shadow-sm whitespace-nowrap">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}